import { FormControl, TextField } from '@mui/material';
import React, { FC } from 'react';

import { regularTextColor } from 'assets/styles/_palette';

import * as Styled from './styled';

interface ICustomTextFieldProps {
	errors: any;
	registerConfig: any;
	isDisabled: boolean;
	defaultValue: string;
}

export const ExpandableTextField: FC<ICustomTextFieldProps> = ({
	errors,
	registerConfig,
	isDisabled,
	defaultValue,
}) => {
	return (
		<FormControl fullWidth error={Boolean(errors)}>
			<TextField
				variant="standard"
				className="rtl-able"
				multiline
				fullWidth
				disabled={isDisabled}
				defaultValue={defaultValue}
				minRows={1}
				maxRows={Infinity}
				InputProps={{
					disableUnderline: true,
				}}
				inputProps={{ style: { color: regularTextColor } }}
				{...registerConfig}
			/>
			<Styled.CustomFormHelperText>{errors?.message || ''}</Styled.CustomFormHelperText>
		</FormControl>
	);
};
